function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _instanceof(left, right) {
    if (right != null && typeof Symbol !== "undefined" && right[Symbol.hasInstance]) {
        return !!right[Symbol.hasInstance](left);
    } else {
        return left instanceof right;
    }
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import React, { useRef, useEffect } from "react";
import { buildTestIdProp } from "@cvent/nucleus-test-automation";
import SearchIcon from "../../Icon/Search";
import Textbox from "../../legacy/Textbox/Textbox";
import { ClearSearchTextButton, MoreFiltersButton } from "./SearchButtons";
import useStyle from "./Search.style";
var useOnClickOutside = function(ref, onClose) {
    useEffect(function() {
        var listener = function(event) {
            if (ref.current && !(_instanceof(ref.current, Node) && ref.current.contains(event.target))) {
                onClose(event);
            }
        };
        document.addEventListener('mousedown', listener);
        document.addEventListener('touchstart', listener);
        return function() {
            document.removeEventListener('mousedown', listener);
            document.removeEventListener('touchstart', listener);
        };
    });
};
export var SearchContainer = function(param) {
    var searchTerm = param.searchTerm, inputRef = param.inputRef, setIsSearchOpen = param.setIsSearchOpen, testID = param.testID, clearSearchTerm = param.clearSearchTerm, searchInputAccessibilityLabel = param.searchInputAccessibilityLabel, clearButtonAccessibilityLabel = param.clearButtonAccessibilityLabel, openFlyoutAccessibilityLabel = param.openFlyoutAccessibilityLabel, _isRtl = param.isRtl, isRtl = _isRtl === void 0 ? false : _isRtl, breakpoints = param.breakpoints, isSearchOpen = param.isSearchOpen, onSearch = param.onSearch, onChange = param.onChange, isFiltersOpen = param.isFiltersOpen, setIsFiltersOpen = param.setIsFiltersOpen, hasFilters = param.hasFilters, children = param.children;
    var searchContainerRef = useRef(null);
    var closeSearch = function() {
        setIsFiltersOpen(false);
        setIsSearchOpen(false);
    };
    useOnClickOutside(searchContainerRef, closeSearch);
    var ref = useStyle({
        isRtl: isRtl,
        breakpoints: breakpoints,
        isSearchOpen: isSearchOpen
    }), searchBarStyles = ref.searchBarStyles, endIconStyles = ref.endIconStyles;
    var EndIcons = function() {
        return _jsxs("div", {
            css: endIconStyles,
            children: [
                searchTerm && _jsx(ClearSearchTextButton, {
                    isRtl: isRtl,
                    breakpoints: breakpoints,
                    testID: testID,
                    isSearchOpen: isSearchOpen,
                    accessibilityLabel: clearButtonAccessibilityLabel,
                    clearSearchTerm: clearSearchTerm,
                    forwardedRef: inputRef,
                    closeSearch: !hasFilters ? closeSearch : undefined
                }),
                hasFilters && _jsx(MoreFiltersButton, {
                    isRtl: isRtl,
                    breakpoints: breakpoints,
                    testID: testID,
                    isSearchOpen: isSearchOpen,
                    accessibilityLabel: openFlyoutAccessibilityLabel,
                    openFilters: function(e) {
                        e.preventDefault();
                        e.stopPropagation();
                        setIsFiltersOpen(function(current) {
                            return !current;
                        });
                    },
                    closeSearch: !isFiltersOpen ? closeSearch : undefined,
                    isFiltersOpen: isFiltersOpen
                })
            ]
        });
    };
    return _jsxs("div", {
        ref: searchContainerRef,
        css: {
            width: '100%'
        },
        children: [
            _jsx(Textbox, _objectSpread({}, buildTestIdProp([
                testID,
                'input'
            ]), {
                accessibilityLabel: searchInputAccessibilityLabel,
                isRtl: isRtl,
                style: searchBarStyles,
                size: "s",
                iconLeft: isRtl ? function() {
                    return _jsx(EndIcons, {});
                } : SearchIcon,
                iconRight: isRtl ? SearchIcon : function() {
                    return _jsx(EndIcons, {});
                },
                value: searchTerm,
                onChangeText: onChange,
                onKeyDown: function(e) {
                    if (e.code === 'Enter') {
                        if (clearSearchTerm) {
                            clearSearchTerm();
                        }
                        if (onSearch) {
                            onSearch();
                        }
                        setIsSearchOpen(false);
                    }
                },
                forwardedRef: inputRef
            })),
            children
        ]
    });
};
